<script>
import Vue from "vue";
import {
  RichTextEditorPlugin,
  Toolbar,
  Link,
  Image,
  Count,
  HtmlEditor,
  QuickToolbar,
  Table,
} from "@syncfusion/ej2-vue-richtexteditor";
Vue.use(RichTextEditorPlugin);

export default {
  name: "HistoryOfIllnessForm",

  data() {
    return {
      templateID: 0,
      notes: {
        historyofIllnessId: 0,
        encounterId: this.$route.query.encounterID,
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNo,
        userName: this.$root.username,
        historyofIllness: ``,
      },
      showAdd: false,
    };
  },
  
  props: {
    templates: Array,
  },

  watch: {

    "$route.query.encounterID"() {
      this.fetchMFHistoryOfIllness();
    },

    templateID() {
      if (!this.templateID) return;

      const templates = this.templates.filter(
        (temp) => temp.tempID == this.templateID
      );

      if (!templates.length) return;

      this.notes.historyofIllness = templates[0].template;
    },
  },

  provide: {
    richtexteditor: [
      Toolbar,
      Link,
      Image,
      Count,
      HtmlEditor,
      QuickToolbar,
      Table,
    ],
  },

  mounted() {
    Promise.all([ this.fetchMFHistoryOfIllness(), ]);
  },

  methods: {
    fetchTemplates() {
      return this.$http
        .get(`MedicalFile/GetMedicalNotesTemplateNames`)
        .then(({ data }) => {
          this.templates = data;
        })
        .catch(() => {});
    },

    saveData() {
      this.$root.loading = true;
      this.$http
        .post(`MedicalFile/MedicalFileHistoryofIllness`, this.notes)
        .then(() => {
          this.$root.loading = false;
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },

    fetchMFHistoryOfIllness() {
      if (!this.$route.query.encounterID) return Promise.reject();

      let url = `MedicalFile/GetPtMedicalFileHistoryofIllnessForEncounter`;
      url += `?PatientID=${this.$route.params.patientID}`;
      url += `&VisitNo=${this.$route.params.visitNo}`;
      url += `&EncounterID=${this.$route.query.encounterID}`;

      return this.$http
        .get(url)
        .then(({ data }) => {
          this.notes = data.length
            ? data[0]
            : {
                historyofIllnessId: 0,
                encounterId: this.$route.query.encounterID,
                patientID: this.$route.params.patientID,
                visitNo: this.$route.params.visitNo,
                userName: this.$root.username,
                historyofIllness: ``,
              };
        })
        .catch(() => {});
    },
  },
};
</script>
<template>
  <div class="w-full flex flex-col">
    <div class="md:w-1/3 sm:w-full p-tiny">
      <label for="grid-template" class="label-control">Template</label>
      <v-select
        class="text-xs bg-white"
        :options="templates"
        :reduce="(temp) => temp.tempID"
        v-model="templateID"
        label="tempName"
      />
    </div>
    <div class="w-full p-tiny">
      <ejs-richtexteditor
        ref="historyOfIllnessRTE"
        v-model.trim="notes.historyofIllness"
        :disabled="
          $root.formatLowercase($root.username) ==
            $root.formatLowercase(notes.userName) ||
          $root.checkAuth('AdminEditMedicalFile')
            ? false
            : true
        "
        :insertImageSettings="{ saveFormat: 'Base64' }"
        :toolbarSettings="{
          items: [
            'Bold',
            'Italic',
            'Underline',
            'StrikeThrough',
            'FontName',
            'FontSize',
            'FontColor',
            'BackgroundColor',
            'LowerCase',
            'UpperCase',
            'SuperScript',
            'SubScript',
            '|',
            'Formats',
            'Alignments',
            'OrderedList',
            'UnorderedList',
            'Outdent',
            'Indent',
            '|',
            'CreateTable',
            'CreateLink',
            'Image',
            '|',
            'ClearFormat',
            'Print',
            'SourceCode',
            'FullScreen',
            '|',
            'Undo',
            'Redo',
          ],
        }"
      >
      </ejs-richtexteditor>
    </div>
    <div class="w-full text-right p-tiny">
      <button
        v-if="
          $root.formatLowercase($root.username) ==
            $root.formatLowercase(notes.userName) ||
            $root.checkAuth('AdminEditMedicalFile')
        "
        class="btn-sm text-sm btn-primary rounded"
        @click.prevent="saveData"
      >
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>
</template>
